import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Get language from localStorage if available, otherwise use detector
const getSavedLanguage = () => {
  try {
    const saved = localStorage.getItem('i18nextLng');
    if (saved && ['en', 'th', 'my'].includes(saved)) {
      return saved;
    }
  } catch {
    // ignore
  }
  return undefined;
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${new Date().getTime()}`,
    },
    // Get saved language or default to Thai
    lng: getSavedLanguage() || 'th',
    // supported languages
    supportedLngs: ['en', 'th', 'my'],
    detection: {
      // check localStorage first, then browser settings
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    fallbackLng: 'en',
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      // disable suspense to make language switching immediate in UI
      useSuspense: false,
    },
  });

export default i18n;
